import { render, staticRenderFns } from "./Epp.vue?vue&type=template&id=84579864&scoped=true"
import script from "./Epp.vue?vue&type=script&lang=js"
export * from "./Epp.vue?vue&type=script&lang=js"
import style0 from "./Epp.vue?vue&type=style&index=0&id=84579864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84579864",
  null
  
)

export default component.exports